import { all, call, put, takeEvery } from 'redux-saga/effects'
import { uploadData } from '../service/api'
import { I18n } from 'react-redux-i18n';
import { showModal } from './modal';

const UPLOAD_REQUEST = 'pv-kultu/dataImport/UPLOAD_REQUEST';
const UPLOAD_SUCCESS = 'pv-kultu/dataImport/UPLOAD_SUCCESS';
const UPLOAD_FAILURE = 'pv-kultu/dataImport/UPLOAD_FAILURE';

const initialState = {};

export const uploadRequest = (file) => ({ type: UPLOAD_REQUEST, payload: file });
export const uploadSuccess = (result) => ({ type: UPLOAD_SUCCESS, result: result });
export const uploadFailure = (error) => ({ type: UPLOAD_FAILURE, error: error });


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPLOAD_REQUEST: {
      return Object.assign({}, initialState);
    }
    case UPLOAD_SUCCESS: {
      const { uploadingError, ...rest } = state;
      return {...rest, uploadingSuccess: true};
    }
    case UPLOAD_FAILURE: {
      const { uploadingSuccess, ...rest } = state;
      return {...rest, uploadingError: action.error.message };
    }
    default:
      return state;
  }
};

export function* uploadFileSaga(action) {
  const file = action.payload;
  try {
    const form = new FormData();
    form.append("file", file);
    const response = yield call(uploadData, form, {});
    const modalProps = {
      messageType: 'SUCCESS',
      message: I18n.t('message.import_data_success', {name: file.name})
    };
    yield put(showModal('MESSAGE', modalProps));
    yield put(uploadSuccess(response));
  } catch (error) {
    console.error(error);
    let message = I18n.t('dataimport.failure');
    if(error.status && error.message) {
      if(error.message.includes('JAXB_PROBLEM')) {
       message = I18n.t('dataimport.failure_xml');
      } else if(error.message.includes("message type")) {
        message = I18n.t('dataimport.failure_type');
      }
    }
    yield put(uploadFailure(Object.assign({}, error, {message: message})));
  }

}

function* watchDataImport() {
  yield takeEvery(UPLOAD_REQUEST, uploadFileSaga);
}

export function* dataImportSagas() {
  yield all([
    watchDataImport(),
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/dataImport.js